<style lang="scss" scoped>
	.appointment-index {
		width: 100%;
		height: 100%;
		background: rgba(1, 1, 1, 1);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.phone-block {
		position: relative;
		background: url('../../assets/appointment/login-ct-bg.png');
		background-size: 100% 100%;
		text-align: center;
		.name {
			text-align: right;
			color: #78567d;
		}
		.input {
			text-align: left;
			input {
				border: none;
				outline: none;
				background: #d3b8c8;
				margin-left: 5px;
				padding-left: 5px;
			}
		}
	}
	@media (min-width:800px) {
		.conetent {
			width: 1280px;
			height: 720px;
			background: url('../../assets/appointment/index-bg-big.png') no-repeat;
			text-align: right;
		}
		.index-login-btn {
			cursor: pointer;
			position: relative;
			top: -1px;
			margin-right: 65px;
		}
		.index-appoint-btn {
			cursor: pointer;
			margin-right: 380px;
			margin-top: 460px;
		}
		.phone-block {
			width: 579px;
			height: 348px;
			padding-top: 120px;
			.go-back {
				position: absolute;
				top: 10px;
				right: 0;
				cursor: pointer;
			}
			.name {
				font-size: 18px;
				margin-bottom: 35px;
			}
			input {
				width: 212px;
				height: 28px;
			}
			.login-btn {
				cursor: pointer;
				margin-bottom: 30px;
			}
			.tip {
				padding-left: 10%;
				padding-right: 10%;
				font-size: 16px;
				color: #78567d;
			}
		}
	}
    @media (max-width:800px) {
		.conetent {
			width: 100%;
			height: 100%;
			background: url('../../assets/appointment/index-bg-small.png') no-repeat;
			background-size: 100% 100%;
			text-align: center;
		}
		.index-login-btn {
			position: relative;
			top: -1px;
			height: 5vh;
			margin-top: 68vh;
			margin-left: 25px;
			margin-right: 25px;
		}
		.index-appoint-btn {
			height: 5vh;
			margin-left: 25px;
			margin-right: 25px;
		}
		.phone-block {
			width: 94%;
			height: 32vh;
			padding-top: 10vh;
			.go-back {
				position: absolute;
				top: 3px;
				right: 0;
				width: 25px;
			}
			.name {
				font-size: 14px;
				margin-bottom: 20px;
			}
			input {
				width: 80%;
				height: 24px;
			}
			.login-btn {
				height: 4vh;
				cursor: pointer;
				margin-bottom: 10px;
    		margin-top: 5px;
			}
			.tip {
				padding-left: 10%;
				padding-right: 10%;
				font-size: 12px;
				color: #78567d;
				transform: scale(0.9);
			}
		}
	}
</style>

<template>
  	<div class="appointment-index">
		<div class="conetent">
			<img 
				@click="phoneShow" 
				class="index-login-btn" 
				src="../../assets/appointment/index-login-btn.png" 
				alt="开启通道"
			>
			<img 
				@click="goAppoint" 
				class="index-appoint-btn" 
				src="../../assets/appointment/index-appoint-btn.png" 
				alt="跳过"
			>
		</div>
		<!-- 手机号输入 -->
		<div v-show="phoneBlockShow" class="modal-block">
			<div class="phone-block">
				<img @click="phoneBlockShow=false" class="go-back" src="../../assets/appointment/back-icon1.png" alt="">
				<Row class="userName">
					<Col span="9" class="name">
						<span>手机号：</span>
					</Col>
					<Col span="14" class="input">
						<input v-model="phoneNumber" type="text">
					</Col>
				</Row>
				<img @click="goLogin" class="login-btn" src="../../assets/appointment/login-btn.png" alt="登录">
				<div class="tip">温馨提示：老用户请输入登录游戏时的手机号，否则无法生成您的专属记忆哦！</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'appoint-index',
	data() {
		return {
			phoneBlockShow: false,
			phoneNumber: '',
			type: 1, //1：跳预约，2：跳官网
		}
	},
	mounted() {
		this.type = this.$route.query.type;
		let number = sessionStorage.getItem("gamePhoneNumber");
		if(number) {
			this.phoneNumber = number;
		}
	},
	methods: {
		phoneShow() {
			this.phoneBlockShow = true;
		},
		goLogin() {
			if(!this.phoneNumber) {
				this.$Message.warning("请输入手机号");
			} else if(this.phoneNumber.length != 11) {
				this.$Message.warning("请输入正确格式的手机号");
			} else {
				this.$http.get('/api/subscribe/getCheckAccountInfo?phone=' + this.phoneNumber).then(res => {
					sessionStorage.setItem('gamePhoneNumber', this.phoneNumber);
					if(res.result.type == '1') {
						this.$router.push({name: 'past-old', query: {phone: this.phoneNumber, type: this.type}});
					} else {
						this.$router.push({name: 'past-new', query: {phone: this.phoneNumber, type: this.type}});
					}
				});
			}
		},
		goAppoint() {
			const width = document.body.clientWidth;
			if(width > 850) {
				this.$router.push({name: 'appoint-home-pc'});
			} else {
				this.$router.push({name: 'appoint-home-mobile'});
			}
		}
	},
}
</script>